module.exports = __webpack_public_path__ + "media/dashboard/assets/images/dot-7738d52b287bd3fd8bb22474c6411c66.svg";